import React from "react";
import {
  Link as RouterLink,
  RouteComponentProps,
  withRouter,
} from "react-router-dom";
import { observer } from "mobx-react";

import { ListItem, ListItemText } from "@material-ui/core";

import ROUTES from "navigation/routes";

import { LinkWrapper } from "./styles";

type Props = RouteComponentProps & {};

const NAVBAR_ITEMS = [
  {
    title: "TIPS",
    route: ROUTES.CONTENT_TIPS,
    rootRoute: ROUTES.CONTENT_TIPS,
  },
];

@observer
class NavBar extends React.Component<Props> {
  render() {
    const { match } = this.props;

    return (
      <>
        {NAVBAR_ITEMS.map(item => (
          <LinkWrapper key={item.route}>
            <ListItem
              component={RouterLink}
              to={item.route}
              selected={match.url.includes(item.rootRoute || item.route)}
            >
              <ListItemText primary={item.title} />
            </ListItem>
          </LinkWrapper>
        ))}
      </>
    );
  }
}

export default withRouter(NavBar);
